import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

export class Header extends Component {
    render() {
        return (
            <div>
                <a href='/logout' className="pull-right">Logout</a>
                <table className="table">
                    <tbody>
                        <tr>
                            <th className="col-md-4"> <Link to="/publish" >Publish</Link></th>
                            <th className="col-md-4"><Link to="/bulkPublish" >Bulk Publish</Link> </th>
                            <th className="col-md-4"><Link to="/report" >Report</Link></th>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(Header);
